<template>
  <div
      class="radius-comp-wrapper"
      :style="wrapperStyle"
      :class="{
      '-border': border,
      '-default-background': defaultColoredBackground,
    }"
  >
    <div class="content-holder">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'radiusContainer',
  props: [
    'side',
    'maxSide',
    'minSide',
    'radius',
    'background',
    'overflow',
    'border',
    'center',
    'hCenter',
    'vCenter',
  ],
  data: () => ({
    defaultColoredBackground: false,
  }),
  computed: {
    imageSrc() {
      const imageFolder = require.context('@ui-kit/assets/images/', true, /\.svg$/);
      return imageFolder(`./${this.svg}`);
    },
    wrapperStyle() {
      const centerProp = {};
      const styleObj = {
        width: this.side,
        'max-width': this.maxSide,
        'min-width': this.minSide,
        'border-radius': this.radius || '50%',
        background: this.background ? this.getBackground() : '',
        overflow: this.overflow || 'hidden',
      };

      if (this.center) {
        const Vcenter = {
          transform: 'translateY(-50%)',
          top: '50%',
        };
        const Hcenter = {
          margin: '0 auto',
        };
        switch (this.center) {
          case 'horizontal':
            Object.assign(centerProp, Hcenter);
            break;
          case 'vertical':
            Object.assign(centerProp, Vcenter);
            break;
          default:
            Object.assign(centerProp, Hcenter, Vcenter);
        }
      }

      return Object.assign(styleObj, centerProp);
    },
  },
  methods: {
    getBackground() {
      if (this.background !== true) {
        return this.background;
      }
      this.defaultColoredBackground = true;
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.radius-comp-wrapper {
  position: relative;

  &.-border {
    border: solid 1px $context-color-6;
  }

  &.-default-background {
    background: $context-color-5;
  }
}

.content-holder {
   @extend %square-container;
}
</style>
